import { toProxiedCdnImageSrc } from './proxiedImageSrc';

export function isStoredMediaUrl(raw: string | undefined | null): boolean {
    return !!raw && raw.includes('/media/read/');
}

export function normalizeAvatarUrl(raw: string | undefined | null): string | undefined {
    const trimmed = raw?.trim();
    if (!trimmed) return undefined;
    if (isStoredMediaUrl(trimmed)) return trimmed;
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    if (trimmed.startsWith('//')) return `https:${trimmed}`;
    return `https://${trimmed}`;
}

export function resolveAvatarImageSrc(raw: string | undefined | null): string | undefined {
    const normalized = normalizeAvatarUrl(raw);
    if (!normalized) return undefined;
    if (isStoredMediaUrl(normalized)) return normalized;
    return toProxiedCdnImageSrc(normalized);
}

export function resolveCoverImageSrc(raw: string | undefined | null): string | undefined {
    return resolveAvatarImageSrc(raw);
}
